import type { GridSlotProps, SlotCount } from './GridSlot';
import type { CardGridCardProps } from './CardGrid';

type GridSlotData = Omit<GridSlotProps, 'children'>;

export const assignGridSlots = (cards: Array<CardGridCardProps>): Array<GridSlotData> => {
  const standardCardCount = cards.filter(card => !card.isFixedHeight).length - 1;
  const standardSlotsCount = 4 - cards.filter(card => card.isFixedHeight).length;
  const primaryCardIndex = cards.findIndex(card => !card.isFixedHeight);

  const getSlotDataForCard = (card: { isFixedHeight?: boolean; isPrimary?: boolean }, index: number): GridSlotData => {
    if (index === primaryCardIndex) {
      return { isPrimary: true, slots: 4 }; // the first non fixed height card is the primary
    }
    if (card.isFixedHeight) {
      return { slots: 1 }; // fixed height cards always take 1 slot.
    }

    if (index === cards.findIndex((card, i) => !card.isFixedHeight && i !== primaryCardIndex)) {
      // First standard card (other than the primary) takes any extra slots available if there are any.
      return { slots: Math.ceil(standardSlotsCount / standardCardCount) as SlotCount };
    }
    return { slots: Math.floor(standardSlotsCount / standardCardCount) as SlotCount };
  };

  return cards.map((card, index) => getSlotDataForCard(card, index));
};
